// extracted by mini-css-extract-plugin
export default {"title-section":"_91Ih+H4HBr","titleSection":"_91Ih+H4HBr","tabs":"UFDTR-+MkT"};
    if(module.hot) {
      // 1648554174776
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  